import { useEffect, useLayoutEffect } from 'react';

/** Same as `useLayoutEffect` on the browser, and `useEffect` when SSR */
export const useIsomorphicLayoutEffect =
  typeof document === 'undefined' ? useEffect : useLayoutEffect;
